var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M978 157L978 185",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 978.5,
    cy: 152.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M973.987 152.19C973.987 148.283 977.288 145.117 981.358 145.117C981.943 145.117 982.511 145.184 983.056 145.308C981.742 144.48 980.187 144 978.519 144C973.814 144 970 147.806 970 152.5C970 157.194 973.814 161 978.519 161C980.814 161 982.895 160.093 984.427 158.62C983.492 159.032 982.454 159.263 981.358 159.263C977.288 159.263 973.987 156.096 973.987 152.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M987.402 151.6L987.37 149.146L985.535 150.719L983.304 150.056L984.112 152.337L982.765 154.381L985.1 154.218L986.499 156.144L987.133 153.763L989.345 152.909L987.402 151.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch8);
export default __webpack_public_path__ + "static/media/church_8.be9b1a570a6ef5380977a2077dc811eb.svg";
export { ForwardRef as ReactComponent };